module.exports = __webpack_public_path__ + "static/img/4.22c2727.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/3/1/zh/4.png
// module id = nRjT
// module chunks = 0